module.exports = __webpack_public_path__ + "img/aboutUs_img3.c9e2908b.svg";